import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FaDownload } from "react-icons/fa6";
import { ChatFileTile, ChatFileTileSkeleton, extractFileName, fileLabel } from "@/components/chat/attachments";
import { Tooltip } from "@/components/ui";
import Button from "@/components/ui/button";
import { useUser } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { useFileDownload } from "./shared";
interface MessageFilesProps {
  files?: string[] | null;
  size?: "sm" | "lg";
}

/** Staff wrapper: gates downloads on the export permission. */
export function MessageFiles(t0) {
  const $ = _c(12);
  const {
    files,
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const {
    download
  } = useFileDownload();
  const {
    currentUser
  } = useUser();
  let t2;
  if ($[0] !== currentUser) {
    t2 = hasPermission(currentUser, PERMISSIONS.DOWNLOADS_EXPORT);
    $[0] = currentUser;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const canDownload = t2;
  if (!files || files.length === 0) {
    return null;
  }
  const t3 = size === "sm" ? "mt-1.5 flex gap-3" : "mt-2 flex gap-4";
  let t4;
  if ($[2] !== canDownload || $[3] !== download || $[4] !== files) {
    let t5;
    if ($[6] !== canDownload || $[7] !== download) {
      t5 = (file, index) => {
        const fileName = extractFileName(file);
        if (fileName === "temp") {
          return <ChatFileTileSkeleton key={index} />;
        }
        return <ChatFileTile key={index} label={fileLabel(fileName)} title={fileName} className="border-border bg-background-secondary hover:bg-hover" labelClassName="max-w-[200px] text-body !text-foreground" action={<Tooltip content={!canDownload ? "You don't have permission to download files" : undefined}><div><Button variant="ghost" onClick={() => download(file)} className="ml-auto h-6 w-6 p-1 !text-muted-foreground hover:!text-primary" icon={<FaDownload size={12} />} disabled={!canDownload} /></div></Tooltip>} />;
      };
      $[6] = canDownload;
      $[7] = download;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = files.map(t5);
    $[2] = canDownload;
    $[3] = download;
    $[4] = files;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}